import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { OVERVIEW_QUOTE, ROUTE_NOTE, ROUTE_STOPS } from "./data";

export default function Editorial() {
  return (
    <section id="journey" data-testid="editorial-section" className="bg-ivory">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow>The Journey</Eyebrow>
            </Reveal>
            <Reveal delay={0.12}>
              <SectionTitle before="Journey" accent="Overview" className="mt-8" />
            </Reveal>

            <Reveal delay={0.2}>
              <p className="mt-9 max-w-xl text-[15px] leading-[1.9] text-fog">
                This 12-day South India journey weaves wildlife, photography, forests, heritage, food and local life
                into one seamless arc. From Bengaluru it winds through Channapatna&rsquo;s toy-making lanes to the
                palaces, silk and sandalwood of Mysuru, and on past the Hoysala carvings of Somanathapura into the
                deep teak forests of Kabini and Nagarhole.
              </p>
              <p className="mt-5 max-w-xl text-[15px] leading-[1.9] text-fog">
                Four safaris later, the route crosses the Western Ghats into Wayanad&rsquo;s coffee and cardamom
                hills, descends to the Malabar kitchens of Thalassery, rides the railway south through paddy fields
                to the bird forests of Thattekad, and finally opens onto the slow water of Vembanad — a houseboat, a
                sadhya, and a farewell at Fort Kochi&rsquo;s Chinese fishing nets.
              </p>
            </Reveal>

            <Reveal delay={0.28}>
              <blockquote
                data-testid="overview-quote"
                className="mt-10 border-l-2 border-saffron pl-6 font-serif text-xl italic leading-[1.6] text-ink md:text-2xl"
              >
                &ldquo;{OVERVIEW_QUOTE}&rdquo;
              </blockquote>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.2}>
              <aside data-testid="route-card" className="border border-ink/10 bg-cream p-8 shadow-sm md:p-10">
                <p className="text-center text-[11px] font-medium uppercase tracking-[0.32em] text-fog">The Route</p>
                <ol className="mt-8">
                  {ROUTE_STOPS.map((stop, i) => (
                    <li key={stop.place} className="relative flex items-center gap-5 pb-6 last:pb-0">
                      {i < ROUTE_STOPS.length - 1 && (
                        <span
                          className="absolute left-[9px] top-6 h-[calc(100%-12px)] border-l border-dashed border-saffron/50"
                          aria-hidden="true"
                        />
                      )}
                      <span
                        className="relative z-10 flex h-[19px] w-[19px] shrink-0 items-center justify-center rounded-full border-2 border-saffron bg-cream"
                        aria-hidden="true"
                      >
                        <span className="h-[7px] w-[7px] rounded-full bg-saffron" />
                      </span>
                      <span data-testid={`route-stop-${i}`} className="flex-1 font-serif text-lg text-ink">
                        {stop.place}
                      </span>
                      <span className="text-xs tracking-[0.14em] text-fog">{stop.days}</span>
                    </li>
                  ))}
                </ol>
                <p className="mt-8 border-t border-ink/10 pt-5 text-center text-[11px] uppercase tracking-[0.18em] text-fog">
                  {ROUTE_NOTE}
                </p>
              </aside>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
